import { apiClient } from './api'
export interface BillingMember {
  id: string; firstName: string; lastName: string; email: string
  organizationStatus: string; connectionStatus: string; canManageBilling: boolean; eligible: boolean
}
export interface BillingDelegation {
  organizationId: string; currentUserId: string; activeResponsibleCount: number; members: BillingMember[]
  history: { id: string; user_id: string; action: string; description: string; reason?: string | null; action_timestamp: string; actor_first_name: string | null; actor_last_name: string | null }[]
}
export interface BillingAccessChange { enabled: boolean; expectedEnabled: boolean; reason: string }
export interface BillingAccessResult { message: string; changed: boolean; currentUserCanManageBilling?: boolean }
const base = '/api/me/billing-access'
export const billingAccessService = {
  list: async (): Promise<BillingDelegation> => (await apiClient.get(base)).data.data,
  change: async (id: string, input: BillingAccessChange, transfer = false): Promise<BillingAccessResult> => {
    const path = `${base}/members/${encodeURIComponent(id)}`
    return (await (transfer ? apiClient.post(`${path}/transfer`, input) : apiClient.patch(path, input))).data.data
  },
}
